export default __webpack_public_path__ + "static/media/final_declarations.65a587ac.svg";